module.exports = __webpack_public_path__ + "static/media/spirit_delivery.3185628c.jpg";